export default __webpack_public_path__ + "static/media/dragon-hover.708db809.png";